import {
	API_GET_ALL_PREREGISTER_QRCODE,
	SET_QR_PREREGISTER,
	API_GET_PREREGISTER_APPOINTMENT,
	API_GET_RECALLS_PREREGISTER,
	API_EXPORT_PREREGISTERS,
	API_GET_PREREGISTERS_LIST,
	API_PATCH_PREREGISTER_REMINDER,
	API_PATCH_PREREGISTER_WAITING_FLAG,
	API_GET_PREREGISTER_APPOINTMENT_FORCE_STATUS,
	API_POST_CHECKIN,
	API_GET_CHECKIN,
} from "actions/preregister";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_GET_ALL_PREREGISTER_QRCODE]: {
		default: "/appointments/preregister",
		v2: "/appointments/preregister",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_PREREGISTER_APPOINTMENT]: {
		default: "/preregister",
		v2: "/preregister",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_PREREGISTER_APPOINTMENT_FORCE_STATUS]: {
		default: "/preregister/forceStatus",
		v2: "/preregister/forceStatus",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_RECALLS_PREREGISTER]: {
		default: "/preregister/recalls",
		v2: "/preregister/recalls",
		currentClient: DEFAULT_CLIENT,
	},
	[API_EXPORT_PREREGISTERS]: {
		default: "/preregister/export",
		v2: "/preregister/export",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_PREREGISTERS_LIST]: {
		default: "/preregister/list",
		v2: "/preregister/list",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_PREREGISTER_REMINDER]: {
		default: "/preregister/reminder",
		v2: "/preregister/reminder",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_PREREGISTER_WAITING_FLAG]: {
		default: (folderId) => `/preregister/${folderId}/waiting`,
		v2: (folderId) => `/preregister/${folderId}/waiting`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_CHECKIN]: {
		default: "/web/preregister",
		v2: "/web/preregister",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CHECKIN]: {
		default: (patientMyLabId) => `/preregister/${patientMyLabId}`,
		v2: (patientMyLabId) => `/preregister/${patientMyLabId}`,
		currentClient: DEFAULT_CLIENT,
	},
}

export function getAllPreregisterQR(search) {
	const version = getVersion(API_GET_ALL_PREREGISTER_QRCODE);
	return {
		type: API_GET_ALL_PREREGISTER_QRCODE,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				params: {
					search,
				},
			},
		},
	};
}

export function qrPreregister(qr) {
	return {
		type: SET_QR_PREREGISTER,
		data: qr,
	};
}

export function getPreregisterAppointment(qrcode, center = null) {
	const version = getVersion(API_GET_PREREGISTER_APPOINTMENT);
	return {
		type: API_GET_PREREGISTER_APPOINTMENT,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				params: {
					qrcode,
					center,
				},
			},
		},
	};
}

export function postPreregisterForceStatusUrgent(folderHelp) {
	const version = getVersion(API_GET_PREREGISTER_APPOINTMENT_FORCE_STATUS);
	return {
		type: API_GET_PREREGISTER_APPOINTMENT_FORCE_STATUS,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "POST",
				data: { folderHelp },
			},
		},
	};
}

export function getRecallsPreregister() {
	const version = getVersion(API_GET_RECALLS_PREREGISTER);
	return {
		type: API_GET_RECALLS_PREREGISTER,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
			},
		},
	};
}

export function exportPreregisters() {
	const version = getVersion(API_EXPORT_PREREGISTERS);
	return {
		type: API_EXPORT_PREREGISTERS,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
			},
		},
	};
}
export function getListPreregisters(args) {
	const version = getVersion(API_GET_PREREGISTERS_LIST);
	return {
		type: API_GET_PREREGISTERS_LIST,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
				params: args,
			},
		},
	};
}

export function saveReminder(preregister) {
	const version = getVersion(API_PATCH_PREREGISTER_REMINDER);
	return {
		type: API_PATCH_PREREGISTER_REMINDER,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "PATCH",
				data: { preregister },
			},
		},
	};
}

export function togglePreregisterWaitingFlag(folderId, waiting) {
	const version = getVersion(API_PATCH_PREREGISTER_WAITING_FLAG);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_PREREGISTER_WAITING_FLAG,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "PATCH",
				data: { waiting },
			},
		},
	};
}

export function postCheckin(data) {
	const version = getVersion(API_POST_CHECKIN);
	return {
		type: API_POST_CHECKIN,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "POST",
				data: data,
			},
		},
	};
}

export function getCheckinsForPatient(patientMyLabId) {
	const version = getVersion(API_GET_CHECKIN);
	const url = typeof version.path === 'function' ? version.path(patientMyLabId) : version.path;
	return {
		type: API_GET_CHECKIN,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "GET",
			},
		},
	};
}
